module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.library.js
 ** module id = 72
 ** module chunks = 0
 **/